import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class MasterStateService extends ConfigurationService {

    public modelPath = 'configuration/states';

    getDTColumns () {
        const self = this;
        return [{
            name: 'state_id',
            title: 'State Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'state_id'
        }, {
            name: 'state_name',
            title: 'State Name',
            data: 'state_name'
        }, {
            name: 'country_name',
            title: 'Country Name',
            data: 'country_name'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-state')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.state_id}" id="checkbox_${full.state_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.state_id}"></label>
						</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
					</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-state')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.state_id}" class="btn btn-secondary">
						<i class="icon-pencil" data-modelPk="${full.state_id}"></i>
						</a>`;
                }
                return '';
            }
        }];
    }
}
